import type * as ents from '@attain-apps/entities'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type * as me from '../../../me'
import type { Feature } from '../feature'
import * as gql from '../gql'
import * as models from '../models'

const getQuery = (
  filters: readonly models.UnitOutcomeAssignment.Filter[],
): ents.core.dms.data.query.Query<models.UnitOutcomeAssignment> => {
  const queryFilters =
    models.UnitOutcomeAssignment.Filter.toQueryFilters(filters)
  return {
    ...(queryFilters ? { filter: queryFilters } : {}),
    selection: {
      '{}': {
        outcomeId: {
          '@>': [
            {
              '@.': '!outcome',
            },
            'recordId',
          ],
        },
        unitId: {
          '@>': [
            {
              '@.': '!personnel',
            },
            'recordId',
          ],
        },
      },
    },
    target: 'ent:!outcome_assignees:!assignee',
  }
}
// TODO: Implement
export const onAssignmentsRequest = store.effects.create(
  (feature: Feature, meFeature: me.Feature) =>
    feature.actions.getAssignments.request.observe().pipe(
      rxjs.withLatestFrom(
        meFeature.contexts.selectors.zoneContext.asObservable,
      ),
      rxjs.filter(
        // ensure that zone context is available with type guard
        <T1, T3>(data: [T1, T3]): data is [T1, NonNullable<T3>] => !!data[1],
      ),
      rxjs.switchMap(([action, zoneContext]) =>
        gql.queries.assignments
          .execute({
            ...zoneContext,
            query: JSON.stringify(getQuery(action.data.filters)),
          })
          .pipe(
            // Handles success
            rxjs.map(assignments =>
              feature.actions.getAssignments.success.from(action).create({
                request: action.data,
                response: assignments,
              }),
            ),
            // Handles error
            rxjs.catchError(error =>
              rxjs.of(
                feature.actions.getAssignments.error.from(action).create({
                  error,
                  request: action.data,
                }),
              ),
            ),
          ),
      ),
    ),
)
